import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
const mixin = {
    mixins: [validationMixin],
    data() {
        return {
            regex: /[^a-zA-Z0-9!”#$%&'()-^/@[;:\],./=~|`{+*}<>?_]/,
        };
    },
    validations: {
        email: {
            required,
            email,
            regex(text) {
                return !this.regex.test(text);
            },
        },
    },
    computed: {
        emailErrors() {
            const errors = [];
            if (!this.$v.email.$dirty) return errors;
            !this.$v.email.required &&
                errors.push(
                    this.$t("please-enter-error", { key: this.$t("email-address-title") })
                );
            !this.$v.email.email &&
                errors.push("正しい形式のメールアドレスを入力してください。");
            !this.$v.email.regex &&
                errors.push(
                    "正しい形式のメールアドレスを入力してください。 "
                );
            return errors;
        },
    },
};

export default mixin;